import type { AnalyticsPeriod } from '@/features/analytics/types';

/**
 * Utility to calculate the ISO date range based on a named analytics period.
 * Results are formatted as ISO-8601 strings for backend compatibility.
 */
export const calculateAnalyticsDateRange = (
  selectedPeriodValue: AnalyticsPeriod,
): { start?: string; end?: string } => {
  const currentDatePoint = new Date();
  const resultRangePayload: { start?: string; end?: string } = {
    end: currentDatePoint.toISOString(),
  };

  if (selectedPeriodValue === 'WEEK') {
    const calculatedStartMoment = new Date(currentDatePoint);
    calculatedStartMoment.setDate(currentDatePoint.getDate() - 7);
    calculatedStartMoment.setHours(0, 0, 0, 0);
    resultRangePayload.start = calculatedStartMoment.toISOString();
    return resultRangePayload;
  }

  if (selectedPeriodValue === 'MONTH') {
    const calculatedStartMoment = new Date(
      currentDatePoint.getFullYear(),
      currentDatePoint.getMonth(),
      1,
      0,
      0,
      0,
      0,
    );
    resultRangePayload.start = calculatedStartMoment.toISOString();
    return resultRangePayload;
  }

  if (selectedPeriodValue === 'YEAR') {
    const calculatedStartMoment = new Date(currentDatePoint.getFullYear(), 0, 1, 0, 0, 0, 0);
    resultRangePayload.start = calculatedStartMoment.toISOString();
    return resultRangePayload;
  }

  return { start: undefined, end: undefined };
};
